module.exports = __webpack_public_path__ + "img/appAsset-brand--defontana.d7561003.svg";